import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { watch, ref, computed } from 'vue';
import { Form } from 'ant-design-vue';
import { areaList } from './area';
export default {
  name: 'XAreaSelect',
  props: {
    province: {
      type: String,
      default: ''
    },
    city: {
      type: String,
      default: ''
    },
    county: {
      type: String,
      default: ''
    },
    // 使用 name 或 code 作为选项的值
    mode: {
      type: String,
      default: 'name',
      validator: value => ['name', 'code'].includes(value)
    }
  },
  emits: ['province-change', 'update:province', 'update:city', 'update:county', 'city-change', 'county-change'],
  setup(props, {
    emit
  }) {
    const formContext = Form.useInjectFormItemContext();
    const selectProvince = ref(props.province);
    const selectCity = ref(props.city);
    const selectCounty = ref(props.county);
    const provinceList = ref(areaList);
    const cityList = ref([]);
    const countyList = ref([]);
    const getOptionValue = option => {
      const {
        value = '',
        label = ''
      } = option || {};
      if (props.mode === 'name') {
        return label;
      } else if (props.mode === 'code') {
        return value;
      }
      return value;
    };
    watch([() => props.province, () => props.city, () => props.county], val => {
      const [tmpProvince, tmpCity, tmpCounty] = val;
      if (!tmpProvince) return;
      const province = areaList.find(t => getOptionValue(t) === tmpProvince);
      if (!province) return;
      const {
        children: cities = []
      } = province;
      selectProvince.value = getOptionValue(province);
      cityList.value = cities;
      if (!tmpCity) return;
      const city = cities.find(t => getOptionValue(t) === tmpCity);
      if (!city) return;
      const {
        children: counties = []
      } = city || {};
      selectCity.value = getOptionValue(city);
      countyList.value = counties;
      if (!tmpCounty) return;
      const county = counties.find(t => getOptionValue(t) === tmpCounty);
      if (!county) return;
      selectCounty.value = getOptionValue(county);
    }, {
      immediate: true
    });
    const handleProvinceChange = (value, option) => {
      if (!option) {
        selectProvince.value = '';
        selectCity.value = '';
        selectCounty.value = '';
        cityList.value = [];
        countyList.value = [];
        emit('update:province', '');
        emit('update:city', '');
        emit('update:county', '');
        emit('province-change', '');
        emit('city-change', '');
        emit('county-change', '');
        formContext.onFieldChange();
        return;
      }
      const {
        children
      } = option || {};
      if (!!children && Array.isArray(children)) {
        cityList.value = children;
        if (children.length > 0) {
          selectCity.value = getOptionValue(children[0]);
          emit('update:city', selectCity.value);
          emit('city-change', selectCity.value, children[0]);
          const {
            children: countyChildren = []
          } = children[0] || {};
          if (countyChildren.length > 0) {
            countyList.value = countyChildren;
            selectCounty.value = getOptionValue(countyChildren[0]);
            emit('update:county', selectCounty.value);
            emit('county-change', selectCounty.value, countyChildren[0]);
          }
        }
      } else {
        cityList.value = [];
      }
      emit('update:province', value);
      emit('province-change', value, option);
      formContext.onFieldChange();
    };
    const handleCityChange = (value, option) => {
      if (!option) {
        selectCity.value = '';
        selectCounty.value = '';
        countyList.value = [];
        emit('update:city', '');
        emit('update:county', '');
        emit('city-change', '');
        emit('county-change', '');
        formContext.onFieldChange();
        return;
      }
      const {
        children
      } = option || {};
      if (!!children && Array.isArray(children)) {
        countyList.value = children;
        if (children.length > 0) {
          selectCounty.value = getOptionValue(children[0]);
          emit('update:county', selectCounty.value);
          emit('county-change', selectCounty.value, children[0]);
        }
      } else {
        countyList.value = [];
      }
      emit('update:city', value);
      emit('city-change', value, option);
      formContext.onFieldChange();
    };
    const handleCountyChange = (value, option) => {
      if (!option) {
        selectCounty.value = '';
        emit('update:county', '');
        emit('county-change', '');
        formContext.onFieldChange();
        return;
      }
      emit('update:county', value);
      emit('county-change', value, option);
      formContext.onFieldChange();
    };
    const fieldNames = computed(() => {
      if (props.mode === 'name') {
        return {
          value: 'label',
          label: 'label'
        };
      } else if (props.mode === 'code') {
        return {
          value: 'value',
          label: 'label'
        };
      }
      return {
        value: 'value',
        label: 'label'
      };
    });
    return {
      provinceList,
      cityList,
      countyList,
      selectProvince,
      selectCity,
      selectCounty,
      handleProvinceChange,
      handleCityChange,
      handleCountyChange,
      fieldNames
    };
  }
};